import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';
import {
  isCardElementEditable,
  isFullFrame,
} from '../../../../../../../services/cards/components/AccountCard/helpers';
import { CONTROL_SECTION as PHOTO_TYPE } from '../../../../helpers';

/**
 * Determines whether an element is the Card's background.
 * We're using a photo element by default.
 *
 * @param {Object} element The element.
 * @param {Boolean} ignoreZIndex wether to ignore the base background index or not
 * @returns {boolean}
 */
export const isElementCardBackground = (element, ignoreZIndex = false) => {
  if (!element) {
    return false;
  }

  const { cardElement, cardElementConfiguration } = element;
  const isPhoto = cardElement.type === CARD_ELEMENT_TYPE.PHOTO;
  const { frame, z_index: zIndex } = cardElement;
  const isFullView = isFullFrame(frame);

  const isEditable = isCardElementEditable(element);

  // This check should preceed everything now that we have a new background type.
  if (cardElementConfiguration?.photo_type === PHOTO_TYPE.BACKGROUND) {
    return true;
  }

  // Never ignore foreground z Index for background resolution
  if (ignoreZIndex) {
    return (
      isPhoto &&
      isFullView &&
      !isEditable &&
      cardElementConfiguration?.photo_type !== PHOTO_TYPE.FOREGROUND
    );
  }

  return isPhoto && isFullView && !isEditable && zIndex === 0;
};
